const siteContent = {

  // ===== HOME PAGE =====
  home: {
    hero: {
      label: "Your Trusted ICT & Media Partner",
      heading: "Powering Ideas with Technology and Media",
      subheading: "End-to-end ICT and media solutions — from cutting-edge software and stunning websites to compelling video content and live streaming.",
      primaryBtn: "Get a Free Quote",
      secondaryBtn: "See Our Services",
    },
    services: {
      heading: "How Can We Help You?",
      subheading: "Whether you're a startup, enterprise, or media organization — we have the tools to bring your digital vision to life.",
    },
    portfolio: {
      heading: "Our Work Speaks for Itself",
      subheading: "We've partnered with clients across industries to deliver impactful digital and media solutions.",
      btnText: "Request Our Full Portfolio →",
    },
    team: {
      heading: "Meet Our Team",
      subheading: "Behind every project is a passionate team dedicated to delivering excellence.",
    },
    cta: {
      heading: "Ready to Take Your Brand to the Next Level?",
      subtext: "Let's collaborate on your next project — from concept to completion, Digital Archdeacon Media is your partner.",
      btnText: "Get a Free Quote",
    },
  },

  // ===== ABOUT PAGE =====
  about: {
    hero: {
      heading: "About Us",
      subheading: "A team of ICT professionals and media creatives passionate about delivering digital excellence.",
    },
    story: {
      heading: "Our Story",
      text: "Digital Archdeacon Media Ltd was founded with one mission — to bridge the gap between technology and storytelling. From Enugu, Nigeria, we serve businesses, churches, NGOs, and enterprises across Africa and beyond.",
    },
    mission: "To empower businesses and organizations through innovative technology and compelling media.",
    vision: "To be Africa's most trusted ICT and media solutions partner.",
  },

  // ===== SERVICES PAGE =====
  services: {
    hero: {
      heading: "Our Services",
      subheading: "Comprehensive ICT and media solutions, designed around your goals.",
    },
    cta: {
      heading: "Not sure which service you need? Let's talk.",
      btnText: "Request a Free Quote",
    },
  },

  // ===== CONTACT PAGE =====
  contact: {
    hero: {
      heading: "Contact Us",
      subheading: "We'd love to hear from you. Reach out and let's start something great.",
    },
  },

  // ===== QUOTE PAGE =====
  quote: {
    hero: {
      heading: "Request a Free Quote",
      subheading: "Tell us about your project and we'll get back to you within 24 hours.",
    },
  },

  // ===== COMPANY INFO =====
  company: {
    name: "Digital Archdeacon Media Ltd",
    email: "info@digitalarchdeacon.com",
    phone: "+234-814-727-6648",
    address: "6 Edwin Amadi Street, One Day, Enugu, Nigeria",
    tagline: "Powering Ideas with Technology and Media",
    whatsapp: "https://wa.me/2348147276648",
  },

}

export default siteContent